import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface Shortcut {
  key: string
  ctrl?: boolean
  shift?: boolean
  alt?: boolean
  action: () => void
  description: string
}

export const useKeyboardShortcuts = (shortcuts: Shortcut[]) => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Don't trigger shortcuts when typing in inputs
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        (event.target instanceof HTMLElement && event.target.isContentEditable)
      ) {
        return
      }

      shortcuts.forEach((shortcut) => {
        const ctrlMatch = shortcut.ctrl ? event.ctrlKey || event.metaKey : !event.ctrlKey && !event.metaKey
        const shiftMatch = shortcut.shift ? event.shiftKey : !event.shiftKey
        const altMatch = shortcut.alt ? event.altKey : !event.altKey
        const keyMatch = event.key.toLowerCase() === shortcut.key.toLowerCase()

        if (ctrlMatch && shiftMatch && altMatch && keyMatch) {
          event.preventDefault()
          shortcut.action()
        }
      })
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts, navigate])
}

export const useGlobalShortcuts = () => {
  const navigate = useNavigate()

  useKeyboardShortcuts([
    {
      key: 'k',
      ctrl: true,
      description: 'Open command palette',
      action: () => {
        // TODO: Open command palette
        console.log('Command palette')
      },
    },
    {
      key: 'd',
      description: 'Go to Dashboard',
      action: () => navigate('/'),
    },
    {
      key: 't',
      description: 'Go to Transactions',
      action: () => navigate('/deposits'),
    },
    {
      key: 'r',
      description: 'Go to Reports',
      action: () => navigate('/reports'),
    },
    {
      key: '/',
      description: 'Focus search',
      action: () => {
        // TODO: Focus search input
        console.log('Focus search')
      },
    },
    {
      key: '?',
      description: 'Show shortcuts help',
      action: () => {
        // TODO: Show shortcuts modal
        console.log('Show shortcuts')
      },
    },
  ])
}


